<!-- eslint-disable max-len -->
<template>
  <Card title="Change Password">
    <template v-slot:button>
      <Button variant="primary" label="Update Password" @clicked="changePassword" />
    </template>
    <template v-slot:body>
      <form-item label='New Password'>
        <template v-slot>
          <div class="relative">
            <Input
              :type="showPassword?'text':'password'"
              v-model="input.new_password"
              placeholder="New Password"
              :error="$v.input.new_password.$dirty && (!$v.input.new_password.required)"
            />
            <a class="absolute top-0 right-0 mr-2 mt-3 " @click="showPassword=!showPassword" style="cursor:pointer">
              <i class="fa" :class="showPassword?'fa-eye-slash':'fa-eye'"></i>
            </a>
          </div>
          <div class="flex flex-col pt-2">
            <text-error v-if="$v.input.new_password.$dirty && !$v.input.new_password.required" text="New Password is required" />
          </div>
        </template>
      </form-item>
      <form-item label='Confirm New Password'>
        <template v-slot>
          <div class="relative">
            <Input
              :type="showConfirmPassword?'text':'password'"
              v-model="input.confirm_new_password"
              placeholder="Confirm New Password"
              :error="$v.input.confirm_new_password.$dirty && (!$v.input.confirm_new_password.sameAsPassword)"
            />
            <a class="absolute top-0 right-0 mr-2 mt-3 " @click="showConfirmPassword=!showConfirmPassword" style="cursor:pointer">
              <i class="fa" :class="showConfirmPassword?'fa-eye-slash':'fa-eye'"></i>
            </a>
          </div>
          <div class="flex flex-col pt-2">
            <text-error v-if="$v.input.confirm_new_password.$dirty && !$v.input.confirm_new_password.sameAsPassword" text="Confirm New Password not match" />
          </div>
        </template>
      </form-item>
    </template>
  </Card>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { validationMixin } from 'vuelidate';
import { required, sameAs } from 'vuelidate/lib/validators';
import { FormItem, Input, TextArea, Button, TextError, Select } from '@/components/Layout/Form';
import Card from '@/components/Layout/Card';

export default {
  name: 'ChangePasswordUser',
  mixins: [validationMixin],
  data: () => ({
    showPassword: false,
    showConfirmPassword: false,
    input: {
      new_password: '',
      confirm_new_password: '',
    },
  }),
  validations: {
    input: {
      new_password: {
        required,
      },
      confirm_new_password: {
        sameAsPassword: sameAs('new_password'),
      },
    },
  },
  computed: {
    ...mapGetters('NotificationModule', ['isLoading', 'getStatus', 'getMessage', 'getErrorCode']),
    ...mapGetters('AuthModule', ['getUser']),
  },
  mounted() {
    this.toggleDashboardProfile(false);
  },
  methods: {
    ...mapActions('UserModule', ['requestChangePasswordUser']),
    async changePassword() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        // const profile = this.$refs.editProfile.input;
        const result = await this.requestChangePasswordUser({
          id: this.getUser.id,
          password: this.input.new_password,
        });
        this.$v.$reset();
        this.input.new_password = '';
        this.input.confirm_new_password = '';
        this.$swal('Update', 'You successfully update the password', 'success');
      }
    },
  },
  components: { Card, FormItem, Input, TextArea, Button, TextError, Select },
};
</script>



// WEBPACK FOOTER //
// src/views/ChangePasswordUser.vue